import { authReducer } from 'core/auth';
import { messageReducer } from 'core/redux';
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

export const reducers = combineReducers({
  auth: authReducer,
  message: messageReducer,
  form,
});

export type AppState = ReturnType<typeof reducers>;
